import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';

import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { initFirebaseBackend } from './authUtils';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
//import { FakeBackendInterceptor } from './core/helpers/fake-backend';
import { SessionCheck } from './core/services/sessioncheck.service';
import { CommonService } from './core/services/CommonService.service';
import { SecurityCheck } from './core/services/security/securitycheck.service';
import { SecureAuthService } from './core/services/security/secureauth.service';
import { ToastrModule } from 'ngx-toastr';
import { VersionControlling } from './core/services/versioning/versionControlling.service';
import { VersionCheckService } from './core/services/versioning/version-check.service';
import { SetupService } from './core/services/setup/setup.service';
import {NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerComponent } from './shared/spinner.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { SafePipe } from './pages/entryForm/DesignList/safePipe';

// if (environment.defaultauth === 'firebase') {
//   initFirebaseBackend(environment.firebaseConfig);
// } else {
//   FakeBackendInterceptor;
// }

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
  ],

  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    PagesModule,
    LayoutsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    NgxBarcodeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [

                    NgxSpinnerModule],

  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    SessionCheck,
    CommonService,SecurityCheck, SecureAuthService,VersionControlling,
    VersionCheckService,SetupService ,NgxSpinnerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
